import { render, staticRenderFns } from "./CloseHandle.vue?vue&type=template&id=2dff87c0&"
import script from "./CloseHandle.vue?vue&type=script&lang=js&"
export * from "./CloseHandle.vue?vue&type=script&lang=js&"
import style0 from "./CloseHandle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports